module.exports = __webpack_public_path__ + "img/DE01153.588703fe.png";